(function () {
  var splash = document.getElementById("kb-splash");
  if (!splash) return;

  /* ── Hide splash on initial page load ── */
  function hideSplash() {
    splash.classList.remove("is-visible");
  }

  /* Wait for page to fully render, then fade out */
  if (document.readyState === "complete") {
    setTimeout(hideSplash, 600);
  } else {
    window.addEventListener("load", function () {
      setTimeout(hideSplash, 600);
    });
  }

  /* ── Show splash when navigating to a new page ── */
  document.addEventListener("click", function (e) {
    var link = e.target.closest("a");
    if (!link) return;

    var href = link.getAttribute("href");

    /* Skip: external links, anchors, new tabs, javascript:, empty */
    if (!href) return;
    if (href.startsWith("#")) return;
    if (href.startsWith("javascript:")) return;
    if (href.startsWith("mailto:")) return;
    if (href.startsWith("tel:")) return;
    if (link.target === "_blank") return;
    if (link.hostname && link.hostname !== window.location.hostname) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey) return;

    /* Show the splash */
    e.preventDefault();
    splash.classList.add("is-leaving");
    splash.classList.add("is-visible");

    /* Navigate after the fade-in completes */
    setTimeout(function () {
      window.location.href = href;
    }, 400);
  });

  /* ── Handle back/forward browser navigation ── */
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      /* Page was loaded from bfcache (back button) */
      splash.classList.remove("is-leaving");
      setTimeout(hideSplash, 300);
    }
  });
})();
